import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchEvaluatorList } from "./evaluatorAPI";

const initialState = [];
const reducers = {};

export const evaluatorListThunk = createAsyncThunk('evaluators/load', async ()=>{
    const payload = await fetchEvaluatorList();
    return payload;
});

const evaluatorListSlice = createSlice({
    name: 'evaluators',
    initialState,
    reducers,
    extraReducers: (builder)=>{
        builder
            .addCase(evaluatorListThunk.fulfilled, (state, action)=> [ ...action.payload ])
    }
});

export default evaluatorListSlice.reducer;